import React, { useMemo, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import axios from 'axios';
import Table from './Table';
import Button from './Button';
import Container from './Container';
import formatNumber from '../utils/formatNumber';

import config from '../config';

import timezone from 'dayjs/plugin/timezone';
import clsx from 'clsx';
import StatsPies from './StatsPies';
import Statstable from './StatsTable';

dayjs.extend(timezone);
dayjs.tz.setDefault('America/New_York');

const formatData = (flips) => {
  // group flips by choiceOfToken
  const groupedFlips = flips.reduce((acc, flip) => {
    if (!acc[flip.choiceOfToken]) {
      acc[flip.choiceOfToken] = [];
    }
    acc[flip.choiceOfToken].push(flip);
    return acc;
  }, {});

  const formatted = Object.keys(groupedFlips).map((flip) => {
    return {
      token: config.flipTokenChoices.find((choice) => choice.id === parseInt(flip))?.name,
      winPercentage: `${formatNumber(((groupedFlips[flip].filter((flip) => flip.didWin).length / groupedFlips[flip].length) * 100).toFixed(0))}%`,
      totalFlips: formatNumber(groupedFlips[flip].length),
      volume: formatNumber(groupedFlips[flip].reduce((acc, flip) => acc + flip.betAmount, 0)),
    };
  });

  return formatted;
};

const TheFlipsStatsPage = () => {
  const [timeFrame, setTimeFrame] = useState('24H');
  const [flips, setFlips] = useState([]);

  const onFetchFlips = async () => {
    const subtractBy = timeFrame === '24H' ? 1 : 7;
    const after = dayjs().subtract(subtractBy, 'day').format('YYYY-MM-DD');

    const res = await axios.get('/api/flips/stats', {
      params: {
        after,
      },
      headers: {
        Authorization: process.env.NEXT_PUBLIC_API_KEY,
      },
    });
    setFlips(formatData(res.data));
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Token',
        accessor: 'token',
      },
      {
        Header: 'Win %',
        accessor: 'winPercentage',
      },
      {
        Header: 'Total Flips',
        accessor: 'totalFlips',
      },
      {
        Header: 'Volume',
        accessor: 'volume',
      },
    ],
    []
  );

  const data = useMemo(() => flips, [flips]);

  useEffect(() => {
    onFetchFlips();
  }, [timeFrame]);

  return (
    <Container>
      <div className='max-w-3xl mx-auto mt-10 flex flex-col gap-10'>
        <StatsPies />
        <Statstable />
      </div>
    </Container>
  );
};

export default TheFlipsStatsPage;
